import styled from '@emotion/styled'

const Root = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
})

const InchGrid = styled.div({
	width: 'max-content',
	display: 'grid',
	gridTemplateColumns: 'repeat(5, max-content)',
	borderLeft: `1px solid black`,
	borderTop: `1px solid black`,
	'> *':  {
		width: '1in',
		height: '1in',
		borderRight: `1px solid black`,
		borderBottom: `1px solid black`,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
})

export const PrintSizeTest = () => {
	return (
		<Root>
			<InchGrid>
				{Array.from({length: 25}, (_, i) => <div>{i + 1}</div>)}
			</InchGrid>
		</Root>
	)
}
